module.exports = "<sis-loading-spinner></sis-loading-spinner>\n<router-outlet></router-outlet>\n";